import { useState } from 'react';
import { ArrowLeft, Mail, CheckCircle, Chrome } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { useSupabaseClient } from '../hooks/useSupabaseClient';
import { validateEmail } from '../lib/validators';
import siteContent from '../data/site-content.json';

export function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { signInWithGoogle } = useSupabaseClient();
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    setError(null);
    setLoading(true);
    
    try {
      const { error } = await signInWithGoogle();
      
      if (error) {
        setError(error.message);
      }
      // Note: If successful, user will be redirected to Google OAuth
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    } finally {
      // Don't set loading to false here as user will be redirected
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Back to Home */}
        <div className="mb-8">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            leftIcon={<ArrowLeft className="w-4 h-4" />}
            className="text-gray-600 dark:text-gray-300"
          >
            Back to Home
          </Button>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 border border-gray-200 dark:border-gray-700">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-full mb-6">
              <Chrome className="w-8 h-8 text-white" />
            </div>
            
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              Welcome Back
            </h1>
            
            <p className="text-gray-600 dark:text-gray-300">
              Sign in with Google to sync your favorite currencies across devices
            </p>
          </div>

          <div className="space-y-6">
            {error && (
              <div className="p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
                <p className="text-red-800 dark:text-red-300 text-sm">{error}</p>
              </div>
            )}

            <Button
              onClick={handleGoogleSignIn}
              loading={loading}
              className="w-full"
              size="lg"
              leftIcon={<Chrome className="w-5 h-5" />}
            >
              Continue with Google
            </Button>
          </div>

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Secure authentication powered by Google OAuth
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}